import { render, staticRenderFns } from "./IconFont.vue?vue&type=template&id=26eb9ee4&"
import script from "./IconFont.vue?vue&type=script&lang=ts&"
export * from "./IconFont.vue?vue&type=script&lang=ts&"
import style0 from "./IconFont.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports